/**
 * Currency Converter pour Shopify
 * Solution pour convertir les prix dans différentes devises
 * - Avec mise à jour automatique des taux via API
 */

var CurrencyConverter = (function() {
  // Configuration privée
  var config = {
    shopCurrency: 'EUR',
    defaultCurrency: 'EUR',
    displayFormat: '{{amount_with_comma_separator}} €',
    moneyFormat: '{{amount_with_comma_separator}}',
    moneyWithCurrencyFormat: '{{amount_with_comma_separator}} €',
    apiUrl: '/api/currency-rates', // URL de l'API de taux de change
    updateInterval: 12 * 60 * 60 * 1000, // 12 heures en millisecondes
    rates: {
      'EUR': 1,
      'USD': 1.08,
      'GBP': 0.86,
      'CAD': 1.48,
      'AUD': 1.65,
      'JPY': 162.5
    }
  };
  
  // Dernière mise à jour des taux
  var lastRatesUpdate = null;
  
  // Devise actuelle
  var currentCurrency = config.defaultCurrency;

  // Symboles des devises
  var currencySymbols = {
    'EUR': '€',
    'USD': '$',
    'GBP': '£',
    'CAD': 'C$',
    'AUD': 'A$',
    'JPY': '¥'
  };

  /**
   * Mettre à jour les taux de change via l'API
   */
  function updateExchangeRates() {
    // Vérifier si une mise à jour est nécessaire
    var now = new Date().getTime();
    if (lastRatesUpdate && now - lastRatesUpdate < config.updateInterval) {
      console.log("Les taux de change ont été mis à jour récemment, pas besoin de mise à jour");
      return Promise.resolve(config.rates);
    }
    
    console.log("Récupération des taux de change depuis l'API...");
    
    return fetch(config.apiUrl)
      .then(function(response) {
        if (!response.ok) {
          throw new Error("Erreur lors de la récupération des taux de change: " + response.status);
        }
        return response.json();
      })
      .then(function(data) {
        if (data.success && data.rates) {
          // Mettre à jour les taux
          config.rates = data.rates;
          lastRatesUpdate = now;
          console.log("Taux de change mis à jour avec succès:", config.rates);
          return config.rates;
        } else {
          throw new Error("Format de réponse invalide");
        }
      })
      .catch(function(error) {
        console.error("Erreur lors de la mise à jour des taux de change:", error);
        console.log("Utilisation des taux par défaut");
        return config.rates;
      });
  }

  /**
   * Convertir un montant d'une devise à une autre
   */
  function convertAmount(amount, fromCurrency, toCurrency) {
    if (!config.rates[fromCurrency] || !config.rates[toCurrency]) {
      return amount;
    }

    // Conversion via la devise de base (EUR)
    return (amount * config.rates[toCurrency]) / config.rates[fromCurrency];
  }

  /**
   * Formater un prix selon la devise
   */
  function formatMoney(cents, format, currency) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || config.moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || '.';
      decimal = decimal || ',';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch(currency) {
      case 'JPY':
        // Pas de décimales pour les yens
        formatString = formatString.replace('{{amount_with_comma_separator}}', '{{amount_no_decimals}}');
        break;
    }

    var match = formatString.match(placeholderRegex);
    
    if (match) {
      var moneyFormat = match[1];
      switch (moneyFormat) {
        case 'amount':
          value = formatWithDelimiters(cents, 2, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }

      formatString = formatString.replace(placeholderRegex, value);
      
      // Remplacer le symbole € par le symbole de la devise actuelle si nécessaire
      if (currency !== 'EUR') {
        formatString = formatString.replace('€', currencySymbols[currency] || currency);
      }
      
      // Éliminer la mention "EUR" qui pourrait rester dans le texte
      formatString = formatString.replace(' EUR', '');
    }

    return formatString;
  }

  /**
   * Mettre à jour les prix sur la page
   */
  function updatePrices() {
    // Ne rien faire si la devise sélectionnée est déjà la devise d'origine
    if (currentCurrency === config.shopCurrency) {
      console.log("La devise sélectionnée est déjà la devise d'origine, pas de conversion nécessaire");
      return;
    }

    // Trouver tous les éléments de prix sur la page
    var priceElements = document.querySelectorAll('.money:not([data-currency-converted])');
    console.log("Éléments de prix à convertir:", priceElements.length);

    priceElements.forEach(function(element) {
      var priceText = element.textContent || element.innerText;
      
      // Stocker le texte original
      if (!element.hasAttribute('data-original-text')) {
        element.setAttribute('data-original-text', priceText);
      }
      
      // Extraire le montant numérique en recherchant uniquement les chiffres
      // et en ignorant tout symbole de devise ou texte
      var numericMatch = priceText.match(/(\d+[.,]?\d*)/);
      
      if (numericMatch && numericMatch[1]) {
        var numericValue = parseFloat(numericMatch[1].replace(',', '.'));
        
        if (!isNaN(numericValue)) {
          // Convertir le montant
          var convertedAmount = convertAmount(numericValue * 100, config.shopCurrency, currentCurrency);
          
          // Formater selon la devise actuelle
          var formattedPrice;
          
          // Format spécifique pour chaque devise
          switch(currentCurrency) {
            case 'USD':
              formattedPrice = '$' + formatWithDelimiters(convertedAmount/100, 2, '.', ',');
              break;
            case 'GBP':
              formattedPrice = '£' + formatWithDelimiters(convertedAmount/100, 2, '.', ',');
              break;
            case 'CAD':
              formattedPrice = 'C$' + formatWithDelimiters(convertedAmount/100, 2, '.', ',');
              break;
            case 'AUD':
              formattedPrice = 'A$' + formatWithDelimiters(convertedAmount/100, 2, '.', ',');
              break;
            case 'JPY':
              formattedPrice = '¥' + formatWithDelimiters(convertedAmount/100, 0, '.', ',');
              break;
            case 'EUR':
            default:
              formattedPrice = formatWithDelimiters(convertedAmount/100, 2, '.', ',') + ' €';
              break;
          }
          
          // Mettre à jour le texte
          element.textContent = formattedPrice;
          element.setAttribute('data-currency-converted', 'true');
        }
      }
    });

    // Déclencher un événement personnalisé
    document.dispatchEvent(new CustomEvent('currency:updated', { detail: { currency: currentCurrency } }));
  }
  
  /**
   * Formater un nombre avec des séparateurs de milliers et décimaux
   */
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || '.';
    decimal = decimal || ',';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = number.toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? (decimal + parts[1]) : '';

    return dollarsAmount + centsAmount;
  }

  /**
   * Réinitialiser les prix à leur valeur d'origine
   */
  function resetToOriginalPrices() {
    console.log("Réinitialisation des prix à leur valeur d'origine");
    
    var priceElements = document.querySelectorAll('[data-original-text]');
    console.log("Éléments de prix à réinitialiser:", priceElements.length);
    
    priceElements.forEach(function(element) {
      var originalText = element.getAttribute('data-original-text');
      if (originalText) {
        element.textContent = originalText;
        element.removeAttribute('data-currency-converted');
      }
    });
  }

  // API publique
  return {
    init: function(options) {
      // Fusionner les options avec la configuration par défaut
      if (options) {
        for (var key in options) {
          if (options.hasOwnProperty(key)) {
            config[key] = options[key];
          }
        }
      }

      // Initialiser la devise actuelle depuis le localStorage
      var savedCurrency = localStorage.getItem('shopify_currency');
      if (savedCurrency && config.rates[savedCurrency]) {
        currentCurrency = savedCurrency;
      } else {
        currentCurrency = config.defaultCurrency;
      }

      // Mettre à jour les taux de change via l'API
      updateExchangeRates().then(function() {
        // Si on n'est pas sur la devise d'origine, mettre à jour les prix
        if (currentCurrency !== config.shopCurrency) {
          setTimeout(updatePrices, 100);
        }
      });

      console.log("Convertisseur de devise initialisé avec la devise:", currentCurrency);
      return this;
    },

    getCurrentCurrency: function() {
      return currentCurrency;
    },

    setCurrentCurrency: function(currency) {
      if (config.rates[currency]) {
        console.log("Changement de devise:", currentCurrency, "->", currency);
        
        // Si on passe d'une devise étrangère à une autre devise étrangère
        if (currentCurrency !== config.shopCurrency && currency !== config.shopCurrency) {
          // On réinitialise d'abord les prix à la devise d'origine
          resetToOriginalPrices();
        }
        
        // Puis on définit la nouvelle devise
        currentCurrency = currency;
        
        // Sauvegarder la préférence
        localStorage.setItem('shopify_currency', currency);
        
        // Si on revient à la devise d'origine, réinitialiser les prix
        if (currency === config.shopCurrency) {
          resetToOriginalPrices();
        } else {
          // Sinon, convertir les prix
          updatePrices();
        }
        return true;
      }
      return false;
    },

    // Nouvelle méthode pour forcer la mise à jour des taux
    refreshRates: function() {
      lastRatesUpdate = null; // Forcer la mise à jour
      return updateExchangeRates().then(function() {
        // Mettre à jour les prix avec les nouveaux taux
        if (currentCurrency !== config.shopCurrency) {
          resetToOriginalPrices();
          updatePrices();
        }
        return config.rates;
      });
    },

    convertAmount: convertAmount,
    formatMoney: formatMoney
  };
})();

// Compatibilité avec le système Shopify Currency
if (typeof Shopify === 'undefined') {
  var Shopify = {};
}

if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    return CurrencyConverter.formatMoney(cents, format, CurrencyConverter.getCurrentCurrency());
  };
}